module.exports = __webpack_public_path__ + "img/logotaawun.f828d666.png";